"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fulfillment = require("./fulfillment");
var _SvgPlaceholder = _interopRequireDefault(require("./SvgPlaceholder"));
var _default = {
  // fulfillment icons
  bopis: _fulfillment.Bopis,
  delivery: _fulfillment.Delivery,
  express_delivery: _fulfillment.ExpressDelivery,
  free_shipping: _fulfillment.FreeShipping,
  in_store: _fulfillment.InStore,
  no_in_store: _fulfillment.NoInStore,
  no_ship_to: _fulfillment.NoShipTo,
  ship_to: _fulfillment.ShipTo,
  locked: _fulfillment.Locked,
  // default icon
  no_icon: _SvgPlaceholder["default"]
};
exports["default"] = _default;
//# sourceMappingURL=svgIcons.js.map